<template>
  <b-container class="container-rda">
    <b-row>
      <b-col>
        <Breadcrumb :breadcrumb="breadcrumb" />
      </b-col>
    </b-row>

    <b-row>
      <b-col>
        <h2 class="purple bold">Editar evento</h2>
      </b-col>
    </b-row>

    <b-row class="teacher-profile mt-50">
      <b-col>
        <b-row>
          <b-col>
            <b-form-group class="required" description>
              <label for="label">Título</label>
              <b-form-input
                v-model="event.title"
                type="text"
                placeholder
                required
              ></b-form-input>
            </b-form-group>
          </b-col>
          <b-col>
            <b-form-group class="required" description>
              <label for="label">Disponível até</label>
              <b-form-input
                v-model="event.available_until"
                type="date"
                required
              ></b-form-input>
            </b-form-group>
          </b-col>

          <b-col class="text-left" v-if="event.attachment_url">
            <b-form-group description>
              <label required for="label text-left">Anexo</label>
              <div class="wrap-button">
                <b-col class="text-right">
                  <a
                    target="_blank"
                    :href="event.attachment_url"
                    class="upload btn"
                    >Acessar anexo</a
                  >
                </b-col>
                <b-col class="text-right">
                  <b-button
                    @click="removeAttachment"
                    class="large"
                    style="background-color: #ef6549"
                    >Remover anexo</b-button
                  >
                </b-col>
              </div>
            </b-form-group>
          </b-col>

          <b-col class="text-left" v-else>
            <b-form-group description>
              <label required for="label text-left">Anexo</label>
              <b-form-file
                accept=".pdf"
                :value="file"
                @input="(f) => setFile(f)"
                plain
                required
              >
              </b-form-file>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="col-8">
            <b-form-group class="required" description>
              <label for="label">Descrição</label>
              <b-form-textarea
                v-model="event.description"
                type="textarea"
                placeholder
                required
              ></b-form-textarea>
            </b-form-group>
          </b-col>
          <b-col class="col-4">
            <b-form-group
              class="required"
              label="Precisa de autorização dos responsáveis?"
              description
            >
              <b-form-radio-group v-model="event.auth_is_required">
                <b-form-radio value="true" placeholder>Sim</b-form-radio>
                <b-form-radio value="false" placeholder required
                  >Não</b-form-radio
                >
              </b-form-radio-group>
            </b-form-group>
          </b-col>
        </b-row>
        <targets :data="event" />
      </b-col>
    </b-row>

    <b-row align-v="center" class="mt-5">
      <b-col class="text-right">
        <b-button
          class="large blue outline"
          :to="{
            name: 'eventos',
          }"
          >Voltar</b-button
        >
        <b-button :disabled="!formFilled" @click="submit" class="large blue"
          >Atualizar evento</b-button
        >
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import httpRda from "../../../http-rda.js";
import Targets from "../../../components/Targets.vue";

export default {
  name: "updateEvent",
  components: { Targets },

  data() {
    return {
      formFilled: false,
      event: null,
      attachment: null,
      file: null,

      breadcrumb: [
        {
          text: "Administração",
          href: "/administracao",
        },
        {
          text: "Eventos",
          href: "/administracao/eventos",
        },
        {
          text: "Editar evento",
          href: "updateEvent",
          active: true,
        },
      ],
    };
  },

  computed: {
    id() {
      return this.$route.params.id;
    },
  },

  watch: {
    event: {
      handler: function (newEvent) {
        this.updateFormFilled(newEvent, this.targets);
      },
      deep: true,
    },
  },

  methods: {
    updateFormFilled(event) {
      this.formFilled =
        event && event.title && event.description && event.available_until;
    },

    getEvent() {
      httpRda.get(`events/${this.id}`).then((response) => {
        this.event = response.data.event;
      });
    },

    async setFile(file) {
      this.file = file;
    },

    async submitFile(id) {
      if (this.file) {
        const bodyFormData = new FormData();
        bodyFormData.append("fileName", this.file.name);
        bodyFormData.append("fileType", "attachment_url");
        bodyFormData.append("file", this.file);

        try {
          await httpRda
            .patch(`/events/${id}`, bodyFormData, {
              headers: { "Content-Type": "multipart/form-data" },
            })
            .then((response) => (this.file.url = response.data.url));
        } catch (error) {
          alert(error);
        }

        this.getEvent();
      }
    },

    async removeAttachment() {
      try {
        const { value: accept } = await this.$swal.fire({
          title: "Tem certeza?",
          text: "Você não poderá reverter isso!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Sim, remover!",
          cancelButtonText: "Não, cancelar!",
          reverseButtons: true,
        });

        if (!accept) {
          return;
        }

        await httpRda
          .patch(`/events/${this.id}`, { attachment_url: null })
          .then(() => (this.file = null));
      } catch (error) {
        alert(error);
      }

      this.getEvent();
    },

    async submit() {
      // eslint-disable-next-line
      const { targets, ...data } = this.event;

      try {
        await httpRda.patch(`/events/${this.id}`, data).then(async () => {
          if (this.file) {
            await this.submitFile(this.id);
          }
        });
        this.$router.push({ name: "eventos" });
      } catch (error) {
        alert(error);
      }
    },
  },

  created() {
    this.getEvent();
  },
};
</script>

<style lang="scss">
.teacher-profile {
  .form-group {
    &.required {
      &:after {
        right: 0;
      }
    }
  }
}

.title-collapse {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;

  h5 {
    flex: 1;
  }

  .btn {
    background: transparent;
    border: 0;

    svg {
      font-size: 16px;
      fill: red;
    }
  }
}

.table-students {
  width: 100%;

  td,
  th {
    font-size: 18px;
    width: 50%;
  }

  th {
    padding-bottom: 20px;
  }

  td {
    padding: 20px 0;
  }

  tr + tr {
    border-bottom: 1px solid $grey5;
  }
}

.student-responsible {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  gap: 10px;

  span {
    background-color: #efefef;
    padding: 4px 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
}

.wrap-tags {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 10px;

  span {
    background-color: #efefef;
    padding: 4px 8px;
    border-radius: 4px;
    box-sizing: border-box;
  }
}

.wrap-button {
  width: 100%;
  display: flex;
  align-items: center;
  flex-direction: row;
  justify-content: flex-start;
  flex-wrap: wrap;
  gap: 6px;
}

.tag {
  background-color: #68c5b7;
  border-radius: 5px;
  color: #ffffff;
  font-weight: 700;
  line-height: 28px;
  margin: 3px 12px 3px 0;
  padding: 0 3px;
  padding-left: 8px;
  padding-right: 8px;
  text-align: center;
  vertical-align: middle;
  max-width: 100%;
}

.container-rda .multiselect__tag-icon:after {
  color: white;
}

input.isInvalid {
  border-color: red;
}
</style>
